import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { ListSubscriptionsResponse } from '@common/types/subscription-manager/list-subscriptions-response';

export class ListSubscriptions implements LoadingAction {
  readonly type = actions.LIST_SUBSCRIPTIONS;
  readonly isLoading = true;
  readonly mainLoader = true;
}

export class ListSubscriptionsSuccess implements LoadingAction {
  readonly type = actions.LIST_SUBSCRIPTIONS_SUCCESS;
  readonly isLoading = false;

  constructor(public summary: ListSubscriptionsResponse) {}
}

export class ListSubscriptionsError implements ErrorAction {
  readonly type = actions.LIST_SUBSCRIPTIONS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export type SubscriptionManagerActions =
  | ListSubscriptions
  | ListSubscriptionsSuccess
  | ListSubscriptionsError;
